// Accès de l'équipe XALTIX (super-admin = tout ; membre = selon son profil)
export const SUPER_PAGES = [
  { to: "/super/tableau-de-bord", perm: "revenue" },
  { to: "/super/entreprises", perm: "companies_read" },
  { to: "/super/facturation", perm: ["quotes", "invoices", "revenue"] },
  { to: "/contacts-xaltix", perm: "leads" },
  { to: "/super/service-client", perm: "support" },
];

export const isTeam = (user) => !!(user?.is_superadmin || user?.is_staff);

export const hasPerm = (user, perm) => {
  if (user?.is_superadmin) return true;
  if (!user?.is_staff || !perm) return false;
  return [].concat(perm).some((p) => user.staff_perms?.includes(p));
};

export const firstTeamPath = (user) => SUPER_PAGES.find((p) => hasPerm(user, p.perm))?.to || "/super/aucun-acces";
